import React from 'react';

import { Row } from '@xingternal/xing-grid';

import * as S from './divider.styles';

export const Divider: React.VFC = () => {
  return (
    <Row>
      <S.StyledDivider />
    </Row>
  );
};
